module.exports = __webpack_public_path__ + "static/images/containers/Challenges/components/Challenge/images/sparkles-bottom-onslaught.d03686d6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Challenges/components/Challenge/images/sparkles-bottom-onslaught.png
// module id = 2845
// module chunks = 11